export default __webpack_public_path__ + "static/organize-29e12bdf3e6d7b15b7365fb75ec9aff8.jpg";